import {AppsAllContent} from "./AppsAllContent.js";
import JSX from "../../helpers/react.js";
import {OneDevAppPage} from "./OneDevAppPage.js";

$(function () {
    const element = document.querySelector('.apps-content');
    if (element) {
        element.append(...<AppsAllContent/>)
    }
    const elemnt2 = document.querySelector<HTMLDivElement>('.one-app-content');
    if (elemnt2) {
        elemnt2.append(<OneDevAppPage id={+elemnt2.dataset.id!}/>);
    }

})